import {
  MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY,
  MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY,
  SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS,
  SPOTLIGHT_TRENDING_RULE_LABELS,
  SpotlightTrendingConfig,
} from '@ivy-monorepo/shared'

type SpotlightTrendingSettingsProps = {
  value: SpotlightTrendingConfig
  onChange: (value: SpotlightTrendingConfig) => void
}

const SpotlightTrendingSettings = ({ value, onChange }: SpotlightTrendingSettingsProps) => {
  const checkinsValid =
    Number.isInteger(value.rules.checkinsPerDay.minCount)
    && value.rules.checkinsPerDay.minCount >= MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY
    && value.rules.checkinsPerDay.minCount <= MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY

  return (
    <div className="spotlight-trending-settings">
      <div className="feature-flag-subtitle feature-flag-subtitle-spaced">
        A venue is flagged <strong>Trending</strong> in the ticker when <strong>either</strong> rule below matches
        (OR logic), within the same search radius as eligibility above. Independent of Sponsored — a venue can be
        both, or neither.
      </div>
      <table className="map-filters-table spotlight-eligibility-table">
        <thead>
          <tr>
            <th>On</th>
            <th>Rule</th>
            <th>Min count</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type="checkbox"
                checked={value.rules.hotPlaces.enabled}
                onChange={e =>
                  onChange({
                    ...value,
                    rules: { ...value.rules, hotPlaces: { enabled: e.target.checked } },
                  })
                }
              />
            </td>
            <td>{SPOTLIGHT_TRENDING_RULE_LABELS.hotPlaces}</td>
            <td className="spotlight-eligibility-na">—</td>
            <td className="feature-flag-subtitle">{SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS.hotPlaces}</td>
          </tr>
          <tr>
            <td>
              <input
                type="checkbox"
                checked={value.rules.checkinsPerDay.enabled}
                onChange={e =>
                  onChange({
                    ...value,
                    rules: {
                      ...value.rules,
                      checkinsPerDay: { ...value.rules.checkinsPerDay, enabled: e.target.checked },
                    },
                  })
                }
              />
            </td>
            <td>{SPOTLIGHT_TRENDING_RULE_LABELS.checkinsPerDay}</td>
            <td>
              <input
                type="number"
                className="map-filter-input spotlight-eligibility-min-input"
                min={MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY}
                max={MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY}
                step={1}
                disabled={!value.rules.checkinsPerDay.enabled}
                value={value.rules.checkinsPerDay.minCount}
                onChange={e =>
                  onChange({
                    ...value,
                    rules: {
                      ...value.rules,
                      checkinsPerDay: {
                        ...value.rules.checkinsPerDay,
                        minCount: Number.parseInt(e.target.value, 10) || 0,
                      },
                    },
                  })
                }
              />
            </td>
            <td className="feature-flag-subtitle">{SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS.checkinsPerDay}</td>
          </tr>
          <tr>
            <td>
              <input
                type="checkbox"
                checked={value.rules.nearHotspot.enabled}
                onChange={e =>
                  onChange({
                    ...value,
                    rules: { ...value.rules, nearHotspot: { enabled: e.target.checked } },
                  })
                }
              />
            </td>
            <td>{SPOTLIGHT_TRENDING_RULE_LABELS.nearHotspot}</td>
            <td className="spotlight-eligibility-na">—</td>
            <td className="feature-flag-subtitle">{SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS.nearHotspot}</td>
          </tr>
        </tbody>
      </table>
      {!checkinsValid ? (
        <div className="feature-flag-subtitle ticker-setting-error">
          Check-ins per day must be between {MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY} and{' '}
          {MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY}.
        </div>
      ) : null}
    </div>
  )
}

export default SpotlightTrendingSettings
